module.exports = __webpack_public_path__ + "static/toucan-8e2d17c171a4685029d5f9ca4d6f6440.svg";